export const UPDATE_PINCH_IN_IMAGE_ZOOMED = 'UPDATE_PINCH_IN_IMAGE_ZOOMED';
export const UPDATE_DOUBLE_CLICK_IMAGE_ZOOMED = 'UPDATE_DOUBLE_CLICK_IMAGE_ZOOMED';
export const RESET_IMAGE_ZOOM_STATUS = 'RESET_IMAGE_ZOOM_STATUS';
